import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipHorizontalCircle12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFlipHorizontalCircle12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M2.989 7.35a3.3 3.3 0 0 0 6.021 0h.966A4.2 4.2 0 0 1 6 10.2l-.216-.006a4.2 4.2 0 0 1-3.762-2.843zm7.962-1.794a.45.45 0 0 1 0 .9h-9.9a.45.45 0 0 1 0-.9zm-4.735-3.75A4.2 4.2 0 0 1 9.977 4.65H9.01a3.3 3.3 0 0 0-6.021 0h-.966A4.2 4.2 0 0 1 6 1.8z"
            />
        </svg>
    );
}
export default memo(IconFlipHorizontalCircle12);
